import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-align_right_fill",
  "use": "icon-align_right_fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-align_right_fill\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M6,6H18V7.5H6Zm3,5h9V9.5H9ZM6,14.5H18V13H6ZM9,18h9V16.5H9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol